import axios from 'axios';
import { filter } from 'lodash';
import {
    SET_DEFAULT_ADDRESS,
    SET_IS_FETCHING_USER_ADDRESSES,
    SET_IS_UPDATING_ADDRESS,
    SET_ORDER_ADDRESS,
    SET_USER_ADDRESSES,
} from 'reducers/actions-types';
import { orderDeliveryAddresses, userAddresses, userAddressSetDefault } from 'constants/api-urls';
import { dispatchError } from 'reducers/helpers';
import { setCart } from 'reducers/modules/cart/helpers';
import checkDuplicatedPromotions from 'util/debug/promotion-code-logger';

/**
 * Set new Address
 * @param {string} address_id
 * @return {function(*=, *=): Promise<>}
 */
export function setAddress({ address_id }) {
    return function(dispatch, getState) {
        dispatch({ type: SET_IS_UPDATING_ADDRESS, isUpdatingAddresses: true });
        return axios
            .post(orderDeliveryAddresses(), { address_id })
            .then(({ data: cart }) => {
                dispatch({ type: SET_ORDER_ADDRESS, addressId: address_id });
                checkDuplicatedPromotions(cart, true, orderDeliveryAddresses());
                setCart(dispatch, getState, cart);
                dispatch({ type: SET_IS_UPDATING_ADDRESS, isUpdatingAddresses: false });
            })
            .catch(e => {
                dispatch({ type: SET_IS_UPDATING_ADDRESS, isUpdatingAddresses: false });
                dispatchError(dispatch, e, {
                    url: orderDeliveryAddresses(),
                    description: e,
                });
            });
    };
}

/**
 * Fetch remote addresses
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
export function fetchAddresses() {
    return function(dispatch) {
        dispatch({ type: SET_IS_FETCHING_USER_ADDRESSES, isFetchingAddresses: true });
        return axios
            .get(userAddresses())
            .then(
                /**
                 *
                 * @param {IAddress[]} data
                 */
                ({ data }) => {
                    dispatch({ type: SET_IS_FETCHING_USER_ADDRESSES, isFetchingAddresses: false });
                    dispatch({ type: SET_USER_ADDRESSES, addresses: data });
                })
            .catch(e => {
                dispatch({ type: SET_IS_FETCHING_USER_ADDRESSES, isFetchingAddresses: false });
                dispatchError(dispatch, e, {
                    url: userAddresses(),
                    description: e,
                });
            });
    };
}

/**
 * Getting current address
 * @return {function(*, *): IAddress}
 */
export function getCurrentAddress() {
    return function(dispatch, getState) {
        const { address_id, addresses } = getState().address;
        return filter(addresses, { id: address_id }).pop();
    };
}

/**
 * Setting default address
 * @param {string} address_id
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
export function setDefaultAddress({ address_id }) {
    return function(dispatch) {
        dispatch({ type: SET_IS_UPDATING_ADDRESS, isUpdatingAddresses: true });
        return axios
            .post(userAddressSetDefault(), { address_id })
            .then(() => {
                dispatch(fetchAddresses());
                dispatch({ type: SET_IS_UPDATING_ADDRESS, isUpdatingAddresses: false });
                dispatch({ type: SET_DEFAULT_ADDRESS, addressId: address_id });
                dispatch({ type: SET_ORDER_ADDRESS, addressId: address_id });
            })
            .catch(e => {
                dispatch({ type: SET_IS_UPDATING_ADDRESS, isUpdatingAddresses: false });
                dispatchError(dispatch, e, {
                    url: userAddressSetDefault(),
                    description: e,
                });
            });
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/address/helpers.js